import React from 'react';
import ClientFollowupPage from './ClientFollowupPage';

const PaymentFollowup = () => (
  <ClientFollowupPage
    title="Payment Followup"
    endpoint="ClientPaymentClientFollowup"
    parentKey="ClientPayment"
    amountLabel="Client Money"
    amountKey="ClientMoney"
  />
);

export default PaymentFollowup;
